import React, { Component } from "react";
import { connect } from "react-redux";
import SortIcon from "components/sort-icon";

const TYPE_TWLD = "twld";
const TYPE_TWLJ = "twlj";
const TYPE_TWLB_SPIDER = "twlb-spider";
const TYPE_TWLB_TERR = "twlb-terr";
const TYPE_TWLB_SHARK = "twlb-shark";

const SORT_FIELD_NAME = "name";
const SORT_FIELD_TEAM = "team";
const SORT_FIELD_GAMES_PLAYED = "games-played";
const SORT_FIELD_GAMES_WON = "games-won";
const SORT_FIELD_KILLS = "kills";
const SORT_FIELD_DEATHS = "deaths";
const SORT_FIELD_TEAMKILLS = "teamkills";
const SORT_FIELD_KNOCKOUTS = "knockouts";
const SORT_FIELD_KILLS_PER_DEATH = "kills-per-death";
const SORT_FIELD_KILLS_PER_MINUTE = "kills-per-minute";
const SORT_FIELD_KILLS_PER_GAME = "kills-per-game";
const SORT_FIELD_DEATHS_PER_GAME = "deaths-per-game";
const SORT_FIELD_ACCURACY = "accuracy";
const SORT_FIELD_TERR_KILLS = "terr-kills";
const SORT_FIELD_REPS_PER_DEATH = "reps-per-death";
const SORT_FIELD_RATING = "rating";
const SORT_FIELD_GAMESCORE = "gamescore";
const SORT_DIRECTION_ASCENDING = "ascending";
const SORT_DIRECTION_DESCENDING = "descending";

const DEFAULT_ROW_HEADINGS = {
  rank: true,
  name: true,
  team: true,
  gameType: true,
  gamesPlayed: true,
  gamesWon: true,
  kills: true,
  deaths: true,
  // kpd: true,
  // kpm: true,
};

class PlayersTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortField: (props.type === TYPE_TWLD || props.type === TYPE_TWLJ ? SORT_FIELD_GAMESCORE : SORT_FIELD_RATING),
      sortDirection: SORT_DIRECTION_DESCENDING,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.setState({
        sortField: (this.props.type === TYPE_TWLD || this.props.type === TYPE_TWLJ ? SORT_FIELD_GAMESCORE : SORT_FIELD_RATING),
        sortDirection: SORT_DIRECTION_DESCENDING,
      });
    }
  }

  sortableHeadingClicked = (field) => {
    const { sortField, sortDirection } = this.state;
    let _sortDirection;

    if (sortField !== field) {
      // just use the existing direction if they are changing fields
      _sortDirection = sortDirection;
    } else {
      // and if its the same field, just toggle direction
      _sortDirection =
        sortDirection === SORT_DIRECTION_ASCENDING
          ? SORT_DIRECTION_DESCENDING
          : SORT_DIRECTION_ASCENDING;
    }

    this.setState({
      sortField: field,
      sortDirection: _sortDirection,
    });
  };

  render() {
    const { type, players } = this.props;
    const { sortField, sortDirection } = this.state;

    let sortedPlayers = [];

    if (sortField === SORT_FIELD_NAME) {
      sortedPlayers = players.sort((a, b) => {
        if (sortDirection === SORT_DIRECTION_ASCENDING) {
          if (a.fcName < b.fcName) return -1;
          if (a.fcName > b.fcName) return 1;
        } else {
          if (b.fcName < a.fcName) return -1;
          if (b.fcName > a.fcName) return 1;
        }
        return 0;
      });
    } else if (sortField === SORT_FIELD_TEAM) {
      sortedPlayers = players.sort((a, b) => {
        if (sortDirection === SORT_DIRECTION_ASCENDING) {
          if (a.fcTeamName < b.fcTeamName) return -1;
          if (a.fcTeamName > b.fcTeamName) return 1;
        } else {
          if (b.fcTeamName < a.fcTeamName) return -1;
          if (b.fcTeamName > a.fcTeamName) return 1;
        }
        return 0;
      });
    } else if (sortField === SORT_FIELD_GAMES_PLAYED) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.roundsPlayed - b.stats.roundsPlayed ||
              a.stats.rating - b.stats.rating
          : b.stats.roundsPlayed - a.stats.roundsPlayed ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_GAMES_WON) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.roundsWon - b.stats.roundsWon ||
              a.stats.rating - b.stats.rating
          : b.stats.roundsWon - a.stats.roundsWon ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_KILLS) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.kills - b.stats.kills || a.stats.rating - b.stats.rating
          : b.stats.kills - a.stats.kills || b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_DEATHS) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.fnDeaths - b.stats.fnDeaths ||
              a.stats.rating - b.stats.rating
          : b.stats.fnDeaths - a.stats.fnDeaths ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_KILLS_PER_DEATH) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.killsPerDeath - b.stats.killsPerDeath ||
              a.stats.rating - b.stats.rating
          : b.stats.killsPerDeath - a.stats.killsPerDeath ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_KILLS_PER_MINUTE) {
      sortedPlayers = players.sort((a, b) => {
        const a_kpm = Math.round((a.stats.killsPer30Min / 30) * 100) / 100;
        const b_kpm = Math.round((b.stats.killsPer30Min / 30) * 100) / 100;

        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a_kpm - b_kpm || a.stats.rating - b.stats.rating
          : b_kpm - a_kpm || b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_KILLS_PER_GAME) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.killsPerGame - b.stats.killsPerGame ||
              a.stats.rating - b.stats.rating
          : b.stats.killsPerGame - a.stats.killsPerGame ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_DEATHS_PER_GAME) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.deathsPerGame - b.stats.deathsPerGame ||
              a.stats.rating - b.stats.rating
          : b.stats.deathsPerGame - a.stats.deathsPerGame ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_RATING) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.rating - b.stats.rating || a.stats.kills - b.stats.kills
          : b.stats.rating - a.stats.rating || b.stats.kills - a.stats.kills;
      });
    } else if (sortField === SORT_FIELD_GAMESCORE) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.gameScoreNew - b.stats.gameScoreNew || a.stats.kills - b.stats.kills
          : b.stats.gameScoreNew - a.stats.gameScoreNew || b.stats.kills - a.stats.kills;
      });
    } else if (sortField === SORT_FIELD_TERR_KILLS) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.fnTerrierKill - b.stats.fnTerrierKill ||
              a.stats.rating - b.stats.rating
          : b.stats.fnTerrierKill - a.stats.fnTerrierKill ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_REPS_PER_DEATH) {
      sortedPlayers = players.sort((a, b) => {
        const a_rpd = a.stats.fnRepels / a.stats.fnDeaths;
        const b_rpd = b.stats.fnRepels / b.stats.fnDeaths;
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a_rpd - b_rpd || a.stats.rating - b.stats.rating
          : b_rpd - a_rpd || b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_KNOCKOUTS) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.fnKnockOuts - b.stats.fnKnockOuts ||
              a.stats.rating - b.stats.rating
          : b.stats.fnKnockOuts - a.stats.fnKnockOuts ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_TEAMKILLS) {
      sortedPlayers = players.sort((a, b) => {
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a.stats.teamKills - b.stats.teamKills ||
              a.stats.rating - b.stats.rating
          : b.stats.teamKills - a.stats.teamKills ||
              b.stats.rating - a.stats.rating;
      });
    } else if (sortField === SORT_FIELD_ACCURACY) {
      sortedPlayers = players.sort((a, b) => {
        const a_acc = (a.stats.kills / (a.stats.fnBulletsFired + a.stats.fnBombsFired + a.stats.fnBurstsFired * 3)) * 100;
        const b_acc = (b.stats.kills / (b.stats.fnBulletsFired + b.stats.fnBombsFired + b.stats.fnBurstsFired * 3)) * 100;
        return sortDirection === SORT_DIRECTION_ASCENDING
          ? a_acc - b_acc || a.stats.rating - b.stats.rating
          : b_acc - a_acc || b.stats.rating - a.stats.rating;
      });
    }

    return (
      <div className="players-table">
        <table>
          <thead>
            {(type === TYPE_TWLD) && (
              <PlayerHeader
                {...DEFAULT_ROW_HEADINGS}
                gameType={type}
                gamescore
                knockouts
                kpd
                kpg
                dpg
                accuracy
                sortField={sortField}
                sortDirection={sortDirection}
                sortFn={this.sortableHeadingClicked}
              />
            )}
            {(type === TYPE_TWLJ) && (
              <PlayerHeader
                {...DEFAULT_ROW_HEADINGS}
                gameType={type}
                gamescore
                teamkills
                knockouts
                kpd
                kpg
                dpg
                accuracy
                sortField={sortField}
                sortDirection={sortDirection}
                sortFn={this.sortableHeadingClicked}
              />
            )}
            {(type === TYPE_TWLB_SPIDER) && (
              <PlayerHeader
                {...DEFAULT_ROW_HEADINGS}
                gameType="twlb"
                kpd
                kpg
                dpg
                accuracy
                terrKills
                rating
                sortField={sortField}
                sortDirection={sortDirection}
                sortFn={this.sortableHeadingClicked}
              />
            )}
            {(type === TYPE_TWLB_TERR) && (
              <PlayerHeader
                {...DEFAULT_ROW_HEADINGS}
                gameType="twlb"
                kpd
                kpg
                dpg
                accuracy
                terrKills
                rating
                sortField={sortField}
                sortDirection={sortDirection}
                sortFn={this.sortableHeadingClicked}
              />
            )}
            {type === TYPE_TWLB_SHARK && (
              <PlayerHeader
                {...DEFAULT_ROW_HEADINGS}
                gameType="twlb"
                kpd
                kpg
                dpg
                terrKills
                repsPerDeath
                rating
                sortField={sortField}
                sortDirection={sortDirection}
                sortFn={this.sortableHeadingClicked}
              />
            )}
          </thead>
          <tbody>
            {sortedPlayers.map((player, i) => {
              // let kpm = 0;
              // if (player.stats.killsPer30Min) {
              //   kpm = Math.round((player.stats.killsPer30Min / 30) * 100) / 100;
              // }
              let accuracy = 0;
              if (player.stats.fnBulletsFired) {
                accuracy = ((player.stats.kills / (player.stats.fnBulletsFired + player.stats.fnBombsFired + player.stats.fnBurstsFired * 3)) * 100).toFixed(1);
              }
              if (player.fcTeamName === "")
                player.fcTeamName = "-";
              if (type === TYPE_TWLD) {
                return (
                  <PlayerRow
                    gameType={type}
                    key={player.fnUserID}
                    rank={i + 1}
                    name={player.fcName}
                    team={player.fcTeamName}
                    gamesPlayed={player.stats.roundsPlayed.toString()}
                    gamesWon={player.stats.roundsWon.toString()}
                    kills={player.stats.kills.toString()}
                    deaths={player.stats.fnDeaths.toString()}
                    knockouts={player.stats.fnKnockOuts.toString()}
                    kpd={player.stats.killsPerDeath.toString()}
                    kpg={player.stats.killsPerGame.toString()}
                    dpg={player.stats.deathsPerGame.toString()}
                    accuracy={accuracy.toString() + "%"}
                    // kpm={kpm.toString()}
                    gamescore={player.stats.gameScoreNew.toString()}
                    sortField={sortField}
                    sortDirection={sortDirection}
                  />
                );
              } if (type === TYPE_TWLJ) {
                return (
                  <PlayerRow
                    gameType={type}
                    key={player.fnUserID}
                    rank={i + 1}
                    name={player.fcName}
                    team={player.fcTeamName}
                    gamesPlayed={player.stats.roundsPlayed.toString()}
                    gamesWon={player.stats.roundsWon.toString()}
                    kills={player.stats.kills.toString()}
                    deaths={player.stats.fnDeaths.toString()}
                    teamkills={player.stats.teamKills.toString()}
                    knockouts={player.stats.fnKnockOuts.toString()}
                    kpd={player.stats.killsPerDeath.toString()}
                    kpg={player.stats.killsPerGame.toString()}
                    dpg={player.stats.deathsPerGame.toString()}
                    accuracy={accuracy.toString() + "%"}
                    // kpm={kpm.toString()}
                    gamescore={player.stats.gameScoreNew.toString()}
                    sortField={sortField}
                    sortDirection={sortDirection}
                  />
                );
              } else if (type === TYPE_TWLB_SPIDER) {
                return (
                  <PlayerRow
                    gameType="twlb"
                    key={player.fnUserID}
                    rank={i + 1}
                    name={player.fcName}
                    team={player.fcTeamName}
                    gamesPlayed={player.stats.roundsPlayed.toString()}
                    gamesWon={player.stats.roundsWon.toString()}
                    kills={player.stats.kills.toString()}
                    deaths={player.stats.fnDeaths.toString()}
                    kpd={player.stats.killsPerDeath.toString()}
                    kpg={player.stats.killsPerGame.toString()}
                    dpg={player.stats.deathsPerGame.toString()}
                    accuracy={accuracy.toString() + "%"}
                    // kpm={kpm.toString()}
                    terrKills={player.stats.fnTerrierKill.toString()}
                    rating={player.stats.rating.toString()}
                    sortField={sortField}
                    sortDirection={sortDirection}
                  />
                );
              } if (type === TYPE_TWLB_TERR) {
                return (
                  <PlayerRow
                    gameType="twlb"
                    key={player.fnUserID}
                    rank={i + 1}
                    name={player.fcName}
                    team={player.fcTeamName}
                    gamesPlayed={player.stats.roundsPlayed.toString()}
                    gamesWon={player.stats.roundsWon.toString()}
                    kills={player.stats.kills.toString()}
                    deaths={player.stats.fnDeaths.toString()}
                    kpd={player.stats.killsPerDeath.toString()}
                    kpg={player.stats.killsPerGame.toString()}
                    dpg={player.stats.deathsPerGame.toString()}
                    accuracy={accuracy.toString() + "%"}
                    // kpm={kpm.toString()}
                    terrKills={player.stats.fnTerrierKill.toString()}
                    rating={player.stats.rating.toString()}
                    sortField={sortField}
                    sortDirection={sortDirection}
                  />
                );
              } else if (type === TYPE_TWLB_SHARK) {
                const rpd = (player.stats.fnRepels / player.stats.fnDeaths).toFixed(2);
                return (
                  <PlayerRow
                    gameType="twlb"
                    key={player.fnUserID}
                    rank={i + 1}
                    name={player.fcName}
                    team={player.fcTeamName}
                    gamesPlayed={player.stats.roundsPlayed.toString()}
                    gamesWon={player.stats.roundsWon.toString()}
                    kills={player.stats.kills.toString()}
                    deaths={player.stats.fnDeaths.toString()}
                    kpd={player.stats.killsPerDeath.toString()}
                    kpg={player.stats.killsPerGame.toString()}
                    dpg={player.stats.deathsPerGame.toString()}
                    // kpm={kpm.toString()}
                    terrKills={player.stats.fnTerrierKill.toString()}
                    repsPerDeath={rpd.toString()}
                    rating={player.stats.rating.toString()}
                    sortField={sortField}
                    sortDirection={sortDirection}
                  />
                );
              } else {
                return null;
              }
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

const PlayerHeader = ({
  gameType,
  rank,
  name,
  team,
  gamesPlayed,
  kills,
  deaths,
  teamkills,
  knockouts,
  terrKills,
  repsPerDeath,
  rating,
  gamescore,
  sortField,
  sortDirection,
  sortFn,
  gamesWon,
  kpd,
  kpm,
  kpg,
  dpg,
  accuracy,
}) => (
  <tr>
    {rank &&
    sortField === SORT_FIELD_RATING &&
    sortDirection === SORT_DIRECTION_DESCENDING ? (
      <th className="players-table--header--rank" nowrap="true">
        <div className="players-table--header--link">
          <span>#</span>
        </div>
      </th>
    ) : null}
    {name ? (
      <th className="players-table--header--name" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_NAME);
          }}
        >
          <span>Name</span>
          {sortField === SORT_FIELD_NAME ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {team ? (
      <th className="players-table--header--team" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TEAM);
          }}
        >
          <span>Team</span>
          {sortField === SORT_FIELD_TEAM ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {gamesPlayed ? (
      <th className="players-table--header--stat games-played" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_GAMES_PLAYED);
          }}
        >
          <span>GP</span>
          {sortField === SORT_FIELD_GAMES_PLAYED ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {gamesWon ? (
      <th className="players-table--header--stat games-won" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_GAMES_WON);
          }}
        >
          <span>Wins</span>
          {sortField === SORT_FIELD_GAMES_WON ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {kills ? (
      <th className="players-table--header--stat kills" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_KILLS);
          }}
        >
          <span>K</span>
          {sortField === SORT_FIELD_KILLS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {deaths ? (
      <th className="players-table--header--stat deaths" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_DEATHS);
          }}
        >
          <span>D</span>
          {sortField === SORT_FIELD_DEATHS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {teamkills ? (
      <th className="players-table--header--stat teamkills" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TEAMKILLS);
          }}
        >
          <span>TKs</span>
          {sortField === SORT_FIELD_TEAMKILLS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {knockouts ? (
      <th className="players-table--header--stat knockouts" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_KNOCKOUTS);
          }}
        >
          <span>KOs</span>
          {sortField === SORT_FIELD_KNOCKOUTS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {kpd ? (
      <th className="players-table--header--stat kpd" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_KILLS_PER_DEATH);
          }}
        >
          <span>KPD</span>
          {sortField === SORT_FIELD_KILLS_PER_DEATH ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {kpm ? (
      <th className="players-table--header--stat kpm" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_KILLS_PER_MINUTE);
          }}
        >
          <span>KPM</span>
          {sortField === SORT_FIELD_KILLS_PER_MINUTE ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {kpg ? (
      <th className="players-table--header--stat kpg" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_KILLS_PER_GAME);
          }}
        >
          <span>KPG</span>
          {sortField === SORT_FIELD_KILLS_PER_GAME ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {dpg ? (
      <th className="players-table--header--stat dpg" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_DEATHS_PER_GAME);
          }}
        >
          <span>DPG</span>
          {sortField === SORT_FIELD_DEATHS_PER_GAME ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {accuracy ? (
      <th className="players-table--header--stat accuracy" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_ACCURACY);
          }}
        >
          <span>Aim</span>
          {sortField === SORT_FIELD_ACCURACY ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {terrKills ? (
      <th className="players-table--header--stat terr-kills" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_TERR_KILLS);
          }}
        >
          <span>TeKs</span>
          {sortField === SORT_FIELD_TERR_KILLS ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {repsPerDeath ? (
      <th className="players-table--header--stat reps-per-death" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_REPS_PER_DEATH);
          }}
        >
          <span>RPD</span>
          {sortField === SORT_FIELD_REPS_PER_DEATH ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {rating ? (
      <th className="players-table--header--stat rating" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_RATING);
          }}
        >
          <span>Rating</span>
          {sortField === SORT_FIELD_RATING ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
    {gamescore ? (
      <th className="players-table--header--stat gamescore" nowrap="true">
        <div
          className="players-table--header--link"
          onClick={() => {
            sortFn(SORT_FIELD_GAMESCORE);
          }}
        >
          <span>Rating</span>
          {sortField === SORT_FIELD_GAMESCORE ? (
            sortDirection === SORT_DIRECTION_ASCENDING ? (
              <SortIcon up />
            ) : (
              <SortIcon down />
            )
          ) : null}
        </div>
      </th>
    ) : null}
  </tr>
);

const PlayerRow = ({
  gameType,
  rank,
  name,
  team,
  gamesPlayed,
  kills,
  deaths,
  teamkills,
  knockouts,
  terrKills,
  repsPerDeath,
  rating,
  gamescore,
  sortField,
  sortDirection,
  gamesWon,
  kpd,
  kpm,
  kpg,
  dpg,
  accuracy,
}) => (
  <tr className="players-table--row">
    {rank &&
    sortField === SORT_FIELD_RATING &&
    sortDirection === SORT_DIRECTION_DESCENDING ? (
      <td className="players-table--row--rank" nowrap="true">
        {rank}
      </td>
    ) : null}
    {name ? (
      <td className="players-table--row--name" nowrap="true">
        {name}
      </td>
    ) : null}
    {team ? (
      <td className="players-table--row--team" nowrap="true">
        {team}
      </td>
    ) : null}
    {gamesPlayed ? (
      <td className="players-table--row--stat games-played" nowrap="true">
        {gamesPlayed}
      </td>
    ) : null}
    {gamesWon ? (
      <td className="players-table--row--stat games-won" nowrap="true">
        {gamesWon}
      </td>
    ) : null}
    {kills ? (
      <td className="players-table--row--stat kills" nowrap="true">
        {kills}
      </td>
    ) : null}
    {deaths ? (
      <td className="players-table--row--stat deaths" nowrap="true">
        {deaths}
      </td>
    ) : null}
    {teamkills ? (
      <td className="players-table--row--stat teamkills" nowrap="true">
        {teamkills}
      </td>
    ) : null}
    {knockouts ? (
      <td className="players-table--row--stat knockouts" nowrap="true">
        {knockouts}
      </td>
    ) : null}
    {kpd ? (
      <td className="players-table--row--stat kpd" nowrap="true">
        {kpd}
      </td>
    ) : null}
    {kpm ? (
      <td className="players-table--row--stat kpm" nowrap="true">
        {kpm}
      </td>
    ) : null}
    {kpg ? (
      <td className="players-table--row--stat kpg" nowrap="true">
        {kpg}
      </td>
    ) : null}
    {dpg ? (
      <td className="players-table--row--stat dpg" nowrap="true">
        {dpg}
      </td>
    ) : null}
    {accuracy ? (
      <td className="players-table--row--stat accuracy" nowrap="true">
        {accuracy}
      </td>
    ) : null}
    {terrKills ? (
      <td className="players-table--row--stat terr-kills" nowrap="true">
        {terrKills}
      </td>
    ) : null}
    {repsPerDeath ? (
      <td className="players-table--row--stat reps-per-death" nowrap="true">
        {repsPerDeath}
      </td>
    ) : null}
    {rating ? (
      <td className="players-table--row--stat rating" nowrap="true">
        {rating}
      </td>
    ) : null}
    {gamescore ? (
      <td className="players-table--row--stat gamescore" nowrap="true">
        {gamescore}
      </td>
    ) : null}
  </tr>
);

const mapStateToProps = (state) => ({
  app: state.app,
});

export default connect(mapStateToProps)(PlayersTable);



// WEBPACK FOOTER //
// ./src/components/players-table/players-table.js